export default __webpack_public_path__ + "assets/31be7cd816484651a4b63de309ded2fc.jpg";